import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./editProfile.css";
import BASE_URL from "../../config";

export default function UserProfileEditor() {
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    password: "",
    address_line_1: "",
    city: "",
    postcode: "",
    contact_number: "",
  });

  const navigate = useNavigate();

  useEffect(() => {
    // Fetch user profile on load
    const fetchUserProfile = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/api/profile/`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("jwt_token")}`, // JWT token from local storage
          },
        });
        // Coalesce nulls to '' -- address_line_1/city/postcode are all
        // still null for most existing users (see users/models.py), and a
        // null value here would flip these inputs from controlled to
        // uncontrolled and throw a React warning.
        setFormData({
          ...response.data,
          address_line_1: response.data.address_line_1 || '',
          city: response.data.city || '',
          postcode: response.data.postcode || '',
        });
      } catch (error) {
        console.error("Error fetching profile:", error);
        alert("Failed to load profile.");
      }
    };
    fetchUserProfile();
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`${BASE_URL}/api/editprofile/`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("jwt_token")}`, // JWT token
        },
      });
      navigate("/user-dashboard/dashboard"); // Redirect after saving
    } catch (error) {
      console.error("Error updating profile:", error);
      alert("Failed to update profile.");
    }
  };

  return (
    <div className="user-profile-container">
      <h2>Edit Profile</h2>
      <form onSubmit={handleSubmit}>
        <div className="user-profile-form-group">
          <label className="user-profile-label">First Name</label>
          <input
            className="user-profile-input"
            type="text"
            name="first_name"
            value={formData.first_name}
            onChange={handleChange}
            required
          />
        </div>

        <div className="user-profile-form-group">
          <label className="user-profile-label">Last Name</label>
          <input
            className="user-profile-input"
            type="text"
            name="last_name"
            value={formData.last_name}
            onChange={handleChange}
            required
          />
        </div>

        <div className="user-profile-form-group">
          <label className="user-profile-label">Email Address</label>
          <input
            className="user-profile-input"
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            disabled
          />
        </div>

        <div className="user-profile-form-group">
          <label className="user-profile-label">Password</label>
          <input
            className="user-profile-input"
            type="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            required
          />
        </div>

        <div className="user-profile-form-group">
          <label className="user-profile-label">Address</label>
          <input
            className="user-profile-input"
            type="text"
            name="address_line_1"
            value={formData.address_line_1}
            onChange={handleChange}
            required
          />
        </div>

        <div className="user-profile-form-group">
          <label className="user-profile-label">City</label>
          <input
            className="user-profile-input"
            type="text"
            name="city"
            value={formData.city}
            onChange={handleChange}
            required
          />
        </div>

        <div className="user-profile-form-group">
          <label className="user-profile-label">Postcode</label>
          <input
            className="user-profile-input"
            type="text"
            name="postcode"
            value={formData.postcode}
            onChange={handleChange}
            required
          />
        </div>

        <div className="user-profile-form-group">
          <label className="user-profile-label">Contact Number</label>
          <input
            className="user-profile-input"
            type="text"
            name="contact_number"
            value={formData.contact_number}
            onChange={handleChange}
            required
          />
        </div>

        <button type="submit" className="user-profile-button">Save</button>
      </form>
    </div>
  );
}
